import { CLI_TOKEN_PARAM, LS_CLI_TOKEN } from "@shared/constants";

import { recoverBrowserSecurityError } from "../storage";

export const getCLILoginToken = () => {
  const CliTokenStorage = recoverBrowserSecurityError(() =>
    localStorage.getItem(LS_CLI_TOKEN)
  );
  if (CliTokenStorage) return CliTokenStorage;
  const params = new URLSearchParams(window.location.search);
  const CliTokenParam = params.get(CLI_TOKEN_PARAM);

  if (!CliTokenParam) return;

  recoverBrowserSecurityError(() =>
    localStorage.setItem(LS_CLI_TOKEN, CliTokenParam)
  );
  return CliTokenParam;
};

export const clearCliToken = () => {
  recoverBrowserSecurityError(() => {
    localStorage.removeItem(LS_CLI_TOKEN);
  });
};
